import { SVGProps } from "react"

const HeartIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 2.857C11.09 1.567 12.76.75 14.5.75c3.08 0 5.5 2.44 5.5 5.545 0 3.808-3.394 6.91-8.537 11.613l-.013.011L10 19.25l-1.45-1.32-.04-.037C3.384 13.195 0 10.096 0 6.295 0 3.19 2.42.75 5.5.75c1.74 0 3.41.817 4.5 2.107Zm0 13.67.1-.1C14.86 12.082 18 9.21 18 6.295c0-2.016-1.5-3.529-3.5-3.529-1.54 0-3.04.998-3.56 2.38H9.07c-.53-1.382-2.03-2.38-3.57-2.38-2 0-3.5 1.513-3.5 3.529 0 2.914 3.14 5.787 7.9 10.132l.1.1Z"
            clipRule="evenodd"
        />
    </svg>
)
export default HeartIcon